import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { clientsByAgeGenderDHIS2NonSRHHeader } from "../components/HeaderAttribute";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const ReportAgeGenderDHIS2NonSRH = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branchName, setBranchName] = useState("");
  const [project, setProject] = useState(0);
  const [projectError, setProjectError] = useState("");
  const [bindProject, setBindProject] = useState([]);

  const [ageGenderFields, setAgeGenderFields] = useState({
    branchProject: "",
    sdp: "",
    area: "",
    serviceCategory: "",
    serviceSubCategory: "",
    servicesName: "",
  });
  const [ageGenderFieldsError, setAgeGenderFieldsError] = useState({
    sdpError: "",
    areaError: "",
    branchProjectError: "",

    serviceCategoryError: "",
    serviceSubCategoryError: "",
    servicesNameError: "",
  });

  const [showTable, setShowTable] = useState(false);

  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [getServicesData, setGetServicesDatas] = useState([]);
  const [getServiceSubCDatas, setGetServiceSubCDatas] = useState([]);
  const [bindServicesName, setBindServicesName] = useState([]);
  const [bindServiceSubCategory, setBindServiceSubCategory] = useState([]);
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindAgeGenderDHIS2NonSRHData, setBindAgeGenderDHIS2SRHData] = useState(
    []
  );
  const [bindServiceCategory, setBindServiceCategory] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);

  const [serviceCategoryNameList, setServiceCategoryNameList] = useState([]);
  const [serviceSubCategoryNameList, setServiceSubCategoryNameList] = useState(
    []
  );
  const [serviceNameList, setServiceNameList] = useState([]);

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      const NameList = ageGenderFields.branchProject
        .map(
          (option) =>
            bindBranchProjectDD?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setBranchProjectNamesList(NameList);
    }

    if (ageGenderFields.sdp) {
      const NameList = ageGenderFields.sdp
        .map((option) => bindSDP?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setSDPNamesList(NameList);
    }

    if (ageGenderFields.area) {
      const NameList = ageGenderFields.area
        .map((option) => bindArea?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setAreaNamesList(NameList);
    }

    if (ageGenderFields.serviceCategory) {
      const NameList = ageGenderFields.serviceCategory
        .map(
          (option) =>
            bindServiceCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceCategoryNameList(NameList);
    }

    if (ageGenderFields.serviceSubCategory) {
      const NameList = ageGenderFields.serviceSubCategory
        .map(
          (option) =>
            bindServiceSubCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceSubCategoryNameList(NameList);
    }

    if (ageGenderFields.servicesName) {
      const NameList = ageGenderFields.servicesName
        .map(
          (option) =>
            bindServicesName?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceNameList(NameList);
    }
  }, [ageGenderFields]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      setBranchName(userProfileDatas[0]?.LocationName_en);

      if (userProfileDatas[0]?.MstSDPId == null) {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: "",
        });
      } else {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: [userProfileDatas[0]?.MstSDPId],
        });
      }
    }
    BranchProjectFetchData();
    serviceCategoryDD();

    fetchAllDropdowns();
  }, [userProfileDatas ? userProfileDatas : undefined]);
  const fetchAllDropdowns = useCallback(async () => {

    try {
      // 🔹 Run APIs in parallel
      const [locationRes, pacServicesRes] = await Promise.all([
        BindAPI("TXNServicesAPI/ServicesDatas"),
        BindAPI("ServicesMasterAPI/BindServicesDropDowns"),
      ]);

      const locData = locationRes.data || {};
      const pacData = pacServicesRes.data || {};

      // 🔹 Extract tables once
      const tables = {
        location: locData.Table2 ?? [],
        area: locData.Table ?? [],
        brand: locData.Table6 ?? [],
        serviceSub: locData.Table5 ?? [],
        services: locData.Table9 ?? [],
        project: locData.Table3 ?? [],
        serviceCategory: locData.Table4 ?? [],
        referredTo: locData.Table8 ?? [],
        pacServices: pacData.Table1 ?? [],
        appointmentWith: locData.Table1 ?? [],
      };

      // 🔹 Filter project by MstBranchProjectId & user organization
      const userOrgId = userProfileDatas[0]?.MstLocationId;

      tables.project = tables.project.filter(
        (item) => item.MstBranchProjectId === userOrgId
      );

      // 🔹 Reusable mapper
      const toOptions = (arr = [], valueKey, labelKey, { filterBlocked = false } = {}) =>
        arr
          .filter(item => !filterBlocked || item.BlockedBy == null)
          .map(item => ({ value: item[valueKey], label: item[labelKey] }));

      // 🔹 Prepare dropdowns
      const dropdowns = {
        bindSDPDD: toOptions(tables.appointmentWith, "MstSDPId", "SDP_en"),
        bindArea: toOptions(tables.area, "MstAreaId", "AreaName_en"),
        bindProject: toOptions(tables.project, "MstProjectId", "ProjectName_en"),
        bindServiceCategory: toOptions(
          tables.serviceCategory,
          "MstServicesCategoryId",
          "ServicesCategory_en"
        ),
        bindReferralDD: toOptions(tables.referredTo, "MstReferredToId", "ReferredTo_en"),
        bindPACServices: toOptions(tables.pacServices, "MstPACServicesId", "PACServices"),
      };

      // 🔹 User-specific SDP dropdown
      const { MstSDPId: userSDPId, MstLocationId: userLocationId } = userProfileDatas[0] || {};
      dropdowns.bindUserSDPDD = tables.appointmentWith
        .filter(item =>
          userSDPId ? item.MstSDPId == userSDPId : item.MstLocationId == userLocationId
        )
        .map(item => ({ value: item.MstSDPId, label: item.SDP_en }));

      setBindProject(dropdowns.bindProject);
    } catch (err) {
      console.error("Error fetching dropdown data:", err);
    } finally {
    }
  }, [userProfileDatas]);

  const GoButton = async () => {
    const branchProjectValidate = ageGenderFields.branchProject
      ? ""
      : "Select Branch/Project";
    const sdpValidate = ageGenderFields.sdp ? "" : "Select SDP";

    const areaValidate = ageGenderFields.area ? "" : "Select Area";

    const serviceCategoryValidate = ageGenderFields.serviceCategory
      ? ""
      : "Select Service Category";
    const serviceSubCategoryValidate = ageGenderFields.serviceSubCategory
      ? ""
      : "Select Service Sub-Category";
    const servicesNameValidate = ageGenderFields.servicesName
      ? ""
      : "Select  Services";
    setAgeGenderFieldsError({
      ...ageGenderFieldsError,
      branchProjectError: branchProjectValidate,
      sdpError: sdpValidate,
      areaError: areaValidate,
      serviceCategoryError: serviceCategoryValidate,
      serviceSubCategoryError: serviceSubCategoryValidate,
      servicesNameError: servicesNameValidate,
    });

    let branchProjectArray = Array.from(
      { length: ageGenderFields.branchProject.length },
      (v, i) => ageGenderFields.branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    let sdpArray = Array.from(
      { length: ageGenderFields.sdp.length },
      (v, i) => ageGenderFields.sdp[i]
    );
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from(
      { length: ageGenderFields.area.length },
      (v, i) => ageGenderFields.area[i]
    );
    let areaResult = areaArray.join(",");

    let serviceCategoryArray = Array.from(
      { length: ageGenderFields.serviceCategory.length },
      (v, i) => ageGenderFields.serviceCategory[i]
    );
    let serviceCategoryResult = serviceCategoryArray.join(",");

    let serviceSubCategoryArray = Array.from(
      { length: ageGenderFields.serviceSubCategory.length },
      (v, i) => ageGenderFields.serviceSubCategory[i]
    );
    let serviceSubCategoryResult = serviceSubCategoryArray.join(",");

    let servicesArray = Array.from(
      { length: ageGenderFields.servicesName.length },
      (v, i) => ageGenderFields.servicesName[i]
    );
    let servicesResult = servicesArray.join(",");

    if (
      !branchProjectValidate &&
      !sdpValidate &&
      !areaValidate &&

      !serviceCategoryValidate &&
      !serviceSubCategoryValidate &&
      !servicesNameValidate
    ) {
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstServicesCategoryId: serviceCategoryResult,
          mstServicesSubCategoryId: serviceSubCategoryResult,
          mstServicesId: servicesResult,

          mstProjectId: project ?? 0,
          fromDate: fromDate,
          toDate: toDate,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "TXNServicesAPI/ReportAgeGenderDHIS2NonSRH"
      );

      setBindAgeGenderDHIS2SRHData(response.data.Table);
      setShowTable(true);
    } else {
    }
  };
  const handleExport = () => {
    const dateRange = {
      fromDate: fromDate,
      toDate: toDate,
    };

    const selectedOptionsData = {
      branchProjectData:
        branchProjectNamesList.length > 0
          ? branchProjectNamesList.toString()
          : branchName,
      sdpData: sdpNamesList.toString(),
      areaData: areaNamesList.toString(),
    };
    exportData(
      clientsByAgeGenderDHIS2NonSRHHeader.map((column) => column.title),
      bindAgeGenderDHIS2NonSRHData,
      dateRange,
      selectedOptionsData
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const titleRow = [
      {
        v: "Age & Gender - Non-SRH",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Date range row with merged cells
    const dateRangeRow = [
      { v: "" },
      {
        v: "From Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: formatDate(dateRange.fromDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
      {
        v: "To Date:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "left" },
        },
      },
      {
        v: formatDate(dateRange.toDate),
        s: {
          alignment: { horizontal: "left" },
        },
      },
    ];

    // Branch information row with merged cells
    const branchRow = [
      { v: "" },
      {
        v: "Branch/Project:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.branchProjectData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "S.D.P.:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.sdpData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },

      {
        v: "Area:",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
        },
      },
      {
        v: selectedDetails.areaData,
        s: {
          alignment: { horizontal: "left" },
          alignment: { wrapText: true }, // Enable text wrapping
        },
      },
    ];

    // Add empty row for spacing
    const spacingRow = [{ v: "" }];

    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true, // Enable text wrapping for headers
          },
        },
      })),
      {
        v: "Total",
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "right" },
        },
      },
    ];
    // Initialize column totals
    const columnTotals = {
      FemaleAge0to24: 0,
      MaleAge0to24: 0,
      OtherAge0to24: 0,
      FemaleAge24Above: 0,
      MaleAge24Above: 0,
      OtherAge24Above: 0,
    };

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      // Calculate row total for numeric fields
      const rowTotal =
        Number(rowData.FemaleAge0to24 || 0) +
        Number(rowData.MaleAge0to24 || 0) +
        Number(rowData.OtherAge0to24 || 0) +
        Number(rowData.FemaleAge24Above || 0) +
        Number(rowData.MaleAge24Above || 0) +
        Number(rowData.OtherAge24Above || 0);
      // Add to column totals
      columnTotals.FemaleAge0to24 += Number(rowData.FemaleAge0to24 || 0);
      columnTotals.MaleAge0to24 += Number(rowData.MaleAge0to24 || 0);
      columnTotals.OtherAge0to24 += Number(rowData.OtherAge0to24 || 0);
      columnTotals.FemaleAge24Above += Number(rowData.FemaleAge24Above || 0);
      columnTotals.MaleAge24Above += Number(rowData.MaleAge24Above || 0);

      columnTotals.OtherAge24Above += Number(rowData.OtherAge24Above || 0);

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Branch,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.SDP,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Area,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
          {
          v: rowData.Project,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.Services_en,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: Number(rowData.FemaleAge0to24 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge0to24 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge0to24 || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.FemaleAge24Above || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.MaleAge24Above || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
        {
          v: Number(rowData.OtherAge24Above || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },

        // Row total
        {
          v: rowTotal,
          t: "n",
          s: {
            ...baseStyle,
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "0",
          },
        },
      ];
    });

    // Create totals row
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
      alignment: { horizontal: "right" },
      numFmt: "0",
    };

    const grandTotal = Object.values(columnTotals).reduce(
      (sum, val) => sum + val,
      0
    );

    const totalsRow = [
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      { v: "", s: totalsRowStyle },
      {
        v: "Total",
        s: { ...totalsRowStyle, alignment: { horizontal: "left" } },
      },
      { v: "", s: totalsRowStyle },
      { v: columnTotals.FemaleAge0to24, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge0to24, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge0to24, t: "n", s: totalsRowStyle },
      { v: columnTotals.FemaleAge24Above, t: "n", s: totalsRowStyle },
      { v: columnTotals.MaleAge24Above, t: "n", s: totalsRowStyle },
      { v: columnTotals.OtherAge24Above, t: "n", s: totalsRowStyle },

      // Grand total
      {
        v: grandTotal,
        t: "n",
        s: {
          ...totalsRowStyle,
          font: { bold: true, color: { rgb: "2D2D6E" } },
        },
      },
    ];
    // Combine all rows
    // const wsData = [titleRow, headerRow, ...dataRows, totalsRow];
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 30 }, //Branch
      { width: 30 }, //Branch
      { width: 30 }, //Branch
      { width: 30 }, // IPC  No
      { width: 30 }, // Gender
      { width: 30 }, // Topics1
      { width: 30 }, // Topics2
      { width: 30 }, // Topics3
      { width: 30 }, // Topics4
      { width: 30 }, // Topics5
    ];


    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // Create and save workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "Age & Gender - Non-SRH.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = clientsByAgeGenderDHIS2NonSRHHeader.map(
      (column) => column.title
    );

    const data = bindAgeGenderDHIS2NonSRHData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.Services_en,
        rowData.FemaleAge0to24,
        rowData.MaleAge0to24,
        rowData.OtherAge0to24,
        rowData.FemaleAge24Above,
        rowData.MaleAge24Above,
        rowData.OtherAge24Above,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Age & Gender - Non-SRH.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  useEffect(() => {
    const getSelectedServiceSubCategory = async () => {
      const serviceSubCategoryResponse = await BindAPI(
        "ServicesSubCategoryAPI/BindServicesSubCategory"
      );
      setGetServiceSubCDatas(serviceSubCategoryResponse.data.Table);
    };
    // Bind service Dropdown datas
    const getSelectedServices = async () => {
      const serviceSubCategoryResponse = await BindAPI(
        "ServicesMasterAPI/BindServices"
      );
      setGetServicesDatas(serviceSubCategoryResponse.data.Table);
    };

    getSelectedServices();

    getSelectedServiceSubCategory();
  }, []);

  const serviceCategoryDD = async () => {
    try {
      const serviceCategoryResponse = await BindAPI(
        "ServicesCategoryAPI/BindServicesCategory"
      );

      const serviceCategoryData = serviceCategoryResponse.data.Table.map(
        (item) => ({
          value: item.MstServicesCategoryId,
          label: item.ServicesCategory_en,
        })
      );

      setBindServiceCategory(serviceCategoryData);
    } catch (error) {
      // Handle API call errors (e.g., show an error message)
    }
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const ageGenderFieldsChange = (value, name) => {
    setAgeGenderFields({
      ...ageGenderFields,
      [name]: value,
    });
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      try {
        const getSelectedSDP = async () => {
          const locationResponse = await BindAPI("SDPAPI/GetSDP");
          setGetSDPDatas(locationResponse.data.Table);

          if (userProfileDatas && userProfileDatas[0]) {
            const sdpLabels = locationResponse.data.Table.filter((item) =>
              ageGenderFields.branchProject.includes(
                parseInt(item.MstLocationId)
              )
            ).map((item) => ({
              MstSDPId: item.MstSDPId,
              SDP_en: item.SDP_en,
            }));

            const sdpSelected = sdpLabels.map((SD) => ({
              value: SD.MstSDPId,
              label: SD.SDP_en,
            }));

            if (
              userProfileDatas[0].MstOrganizationId == 1 ||
              userProfileDatas[0].MstOrganizationId == 2
            ) {
              setBindSDP(sdpSelected);
            } else {
              const allSDPIds = userProfileDatas[0]?.AllSDP;
              const sdpId = userProfileDatas[0]?.MstSDPId;

              if (allSDPIds && Array.isArray(allSDPIds)) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  allSDPIds.includes(sdp.value)
                );
                setBindSDP(filteredSdpSelected);
              }
              if (sdpId) {
                setBindSDP([]);
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  Array.isArray(sdpId)
                    ? sdpId.includes(sdp.value)
                    : sdpId === sdp.value
                );
                setBindSDP(filteredSdpSelected);
              }
            }
          }
        };

        getSelectedSDP();
      } catch (e) {
      }
    }
  }, [
    ageGenderFields.branchProject ? ageGenderFields.branchProject : undefined,
    userProfileDatas ? userProfileDatas : undefined,
  ]);

  useEffect(() => {
    if (ageGenderFields.sdp) {
      try {
        const getSelectedArea = async () => {
          const locationResponse = await BindAPI("AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            ageGenderFields.sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {
      }
    }
  }, [ageGenderFields.sdp ? ageGenderFields.sdp : undefined]);

  useEffect(() => {
    // Bind Services Sub Category Dropdown datas

    const serviceSubCategorySelectedValue = ageGenderFields.serviceCategory;
    setBindServiceSubCategory([]);
    if (serviceSubCategorySelectedValue) {
      const serviceSubCategoryLabels = getServiceSubCDatas
        .filter((item) =>
          serviceSubCategorySelectedValue.includes(item.MstServicesCategoryId)
        )
        .map((item) => ({
          MstServicesSubCategoryId: item.MstServicesSubCategoryId,
          ServicesSubCategory_en: item.ServicesSubCategory_en,
        }));

      const servicesSubCategorySelected = serviceSubCategoryLabels.map(
        (AR) => ({
          value: AR.MstServicesSubCategoryId,
          label: AR.ServicesSubCategory_en,
        })
      );
      setBindServiceSubCategory(servicesSubCategorySelected);
    } else {
    }
  }, [ageGenderFields.serviceCategory]);

  useEffect(() => {
    // Bind Services Dropdown datas

    const selectedSubCategories = ageGenderFields.serviceSubCategory;
    setBindServicesName([]);
    if (selectedSubCategories.length > 0) {
      const servicesLabels = getServicesData
        .filter((item) =>
          selectedSubCategories.includes(item.MstServicesSubCategoryId)
        )
        .map((item) => ({
          MstServicesId: item.MstServicesId,
          Services_en: item.Services_en,
        }));

      const servicessSelected = servicesLabels.map((AR) => ({
        value: AR.MstServicesId,
        label: AR.Services_en,
      }));
      setBindServicesName(servicessSelected);
    } else {
      // Handle the case when no sub-categories are selected
      setBindServicesName([]);
    }
  }, [ageGenderFields.serviceSubCategory]);

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Age & Gender - Non-SRH`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      ageGenderFields.branchProject?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={ageGenderFields.branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      ageGenderFieldsChange(e, "branchProject");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {ageGenderFieldsError.branchProjectError && (
                    <span className="text-red-500">
                      {ageGenderFieldsError.branchProjectError}
                    </span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="branchName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.sdp?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="sdp"
                  selectedOptions={ageGenderFields.sdp}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    ageGenderFieldsChange(e, "sdp");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.sdpError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.sdpError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.area?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="area"
                  selectedOptions={ageGenderFields.area}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    ageGenderFieldsChange(e, "area");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.areaError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.areaError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Category"
                  filteredOptions={bindServiceCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceCategory"
                  selectedOptions={ageGenderFields.serviceCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    ageGenderFieldsChange(e, "serviceCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Sub-Category"
                  filteredOptions={bindServiceSubCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceSubCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceSubCategory"
                  selectedOptions={ageGenderFields.serviceSubCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    ageGenderFieldsChange(e, "serviceSubCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceSubCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceSubCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Services"
                  filteredOptions={bindServicesName}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.servicesName?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="servicesName"
                  selectedOptions={ageGenderFields.servicesName}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    setShowTable(false);
                    ageGenderFieldsChange(e, "servicesName");
                  }}
                />
                {ageGenderFieldsError.servicesNameError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.servicesNameError}
                  </span>
                )}
              </div>
            </div>
            <div class={mainTable.grid3}>
              <AutoDropDown
                // classStar="text-red-500"
                title="Project"
                options={bindProject}
                placeholder="Select"
                name="project"
                disabled={false}
                selectedOption={bindProject?.find(
                  (x) => x.value === project
                )}
                controlFunc={(value) => {
                  setProject(value.value);
                  setProjectError(""); // clear error on change
                }}
                controlFuncBlur={() => {
                  setProjectError(project ? "" : "Select Project");
                }}
                Class="custom-class"
                tabIndex={1}
              // errorMessage={projectError}
              />
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setFromDate(e.target.value);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setShowTable(false);
                  setToDate(e.target.value);
                }}
              />
              {/* <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div> */}
            </div>
            <div className={mainTable.grid3}>
              <div></div>
              <div className="flex justify-center items-center mt-6">
                <button
                  type="button"
                  onClick={GoButton}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindAgeGenderDHIS2NonSRHData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={clientsByAgeGenderDHIS2NonSRHHeader}
                records={bindAgeGenderDHIS2NonSRHData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default ReportAgeGenderDHIS2NonSRH;
